





































































































































































import { Component, Mixins, Watch, Prop } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import { forOwn } from 'lodash'
import axios from 'axios'

import { Meta } from '@/helpers/decorators'
import { downloadFileUrl, downloadFileUrlWithoutBlob } from '@/helpers/download'
import { ReportStateType } from '@/enums/ReportStateType'

// Api
import { mapData, REPORT_ROW_API_MAPPING, MISSION_API_MAPPING } from '@/api/Mapping'

// Mixins
import Phone from '@/mixins/Phone'
import Errors from '@/mixins/Errors'
import Table from '@/mixins/Table'
import Filters from '@/mixins/Filter'
import Date from '@/mixins/Date'

// Models
import ReportRow from '@/models/ReportRow'
import TemplateTitle from '@/models/TemplateTitle'

// Components
import Box from '@/components/common/Box.vue'
import DateRanger from '@/components/common/DateRanger.vue'
import StateTag from '@/components/common/StateTag.vue'
import DownloadAppPhoneInput from '@/components/fields/DownloadAppPhoneInput.vue'
import ImageViewerValue from '@/components/common/ImageViewerValue.vue'
import TemplateCategoriesBox from '@/views/all/boxes/TemplateCategoriesBox.vue'
import AssignReportForm from '@/views/all/forms/AssignReportForm.vue'

// Views
import Exporter from '@/views/all/export/Exporter.vue'

@Component({
  components: {
    Box,
    DateRanger,
    StateTag,
    Exporter,
    DownloadAppPhoneInput,
    ImageViewerValue,
    TemplateCategoriesBox,
    AssignReportForm
  }
})
export default class ReportsList extends Mixins(Table, Filters, Phone, Errors, Date) {
  // Pagination
  offset = 0
  limit = 20
  end = false
  templateModalOpened = false
  templateFilter = null
  showAssignReportModal = false
  selectedReport = null

  @Prop({ type: String, default: 'pending_first,pending_second,finished' }) state!: string
  @Prop({ type: String, default: 'all' }) type!: string
  @Prop({ type: Number, default: null }) itemID: number

  @Getter('token') token
  @Getter('locale', { namespace: 'user' }) locale
  @Getter('isAdmin', { namespace: 'user' }) isAdmin

  @Watch('$route', { immediate: true })
  async fetchReportsWithParams(route) {
    this.offset = 0
    this.search = route.query.search ? route.query.search : null
    this.startDate = route.query.range ? route.query.range.split(',')[0] : null
    this.endDate = route.query.range ? route.query.range.split(',')[1] : null

    if (route.query.template) {
      const res = await this.$api.templates.fetchTemplateTitle(this.token, route.query.template)
      this.templateFilter = new TemplateTitle(res.data, this.locale)
    }

    await this.fetch(false)
  }

  @Watch('locale')
  async updateDataWithCurrentLocale() {
    this.offset = 0
    await this.fetch(false)
  }

  @Watch('showAssignReportModal')
  updateSelectedReport(show) {
    if (!show) {
      this.selectedReport = null
    }
  }

  @Meta
  metas() {
    return {
      title: this.$t('menu.reports'),
      titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
    }
  }

  get selectedTemplate() {
    return this.$route.query.template || null
  }

  get params(): {} {
    const params = {
      limit: this.limit,
      offset: this.offset,
      state: this.state,
    }

    forOwn(this.$route.query, (value, key) => {
      params[key] = value
    })

    return params
  }

  parseReport(report) {
    const model = new ReportRow(mapData(REPORT_ROW_API_MAPPING, report, false, true))
    model.parseRow(report, this.locale)
    return model
  }

  isFinished(report): boolean {
    return report.state === ReportStateType.Finished
  }

  isReturn(report): boolean {
    return report.state === ReportStateType.Return
  }

  isWaiting(report): boolean {
    return report.state === ReportStateType.Waiting
  }

  async assignReport(first, formData) {
    if (!this.selectedReport) {
      return
    }
    try {
      const data = {...formData, proovCode: this.selectedReport.proovCode, reportState: 'pending_first' }
      if (this.isReturn(this.selectedReport) && first) {
        data.reportState = 'pending_second'
      }
      await this.$api.missions.createMission(this.token, mapData(MISSION_API_MAPPING, data, true, false))
      this.showAssignReportModal = false
      this.$toast.open({
        message: this.$t('global.info_box.create_success_content') as string,
        type: 'is-success',
        duration: 5000
      })
    } catch (error) {
      this.displayErrors(error)
    }
  }

  async fetch(add: boolean) {
    try {
      this.tableLoading = true
      const res = this.itemID ?
        await this.$api.items.fetchReports(this.token, this.params, this.itemID) :
        await this.$api.reports.fetchReports(this.token, this.params)
      const reports = res.data.map((item) => this.parseReport(item))
      this.data = add ? [...this.data, ...reports] : reports
      this.end = reports.length === 0
      // this.end = reports.length === 0 || reports.length < this.limit
      this.offset += this.limit
    } finally {
      this.tableLoading = false
    }
  }

  async mounted() {
    const res = await this.$api.reports.fetchReports(this.token, { state: this.state, range: this.range })
    this.firstLoad = false
    this.hasData = res.data.length > 0
  }

  async loadMore() {
    await this.fetch(true)
  }

  openAssignReportModal() {
    this.showAssignReportModal = true
  }

  startAssignmentReport(report) {
    this.selectedReport = report
    this.openAssignReportModal()
  }

  goToReport(proovCode) {
    this.$router.push({ name: 'singleReport', params: { id: proovCode } })
  }

  showTemplateSelectorModale(event) {
    this.templateModalOpened = true
  }

  async updateTemplate(datas) {
    this.templateModalOpened = false
    const res = await this.$api.templates.fetchTemplateTitle(this.token, datas.template.id)
    this.templateFilter = new TemplateTitle(res.data, this.locale)
    this.$router.push({ query: Object.assign({}, this.$route.query, { template: datas.template.id }) })
  }

  // TODO Refactoring EXPORTS
  async exportReport(report, format) {
    try {
      this.tableLoading = true
      const res = await this.$api.reports.exportReports(this.token, [report.proovCode], true, format)
      downloadFileUrlWithoutBlob(`report-${report.proovCode}.csv`, res.data.url)
    } catch (error) {
      this.displayErrors(error)
    } finally {
      this.tableLoading = false
    }
  }

  async exportReports(download, format) {
    try {
      this.tableLoading = true
      // @ts-ignore
      const codes = this.checkedRows.map((report) => report.proovCode)
      const res = await this.$api.reports.exportReports(this.token, codes, download, format)
      downloadFileUrlWithoutBlob(`reports.${format}`, res.data.url)
    } catch (error) {
      this.displayErrors(error)
    } finally {
      this.tableLoading = false
    }
  }

  async dispatchExport(exporter) {
    switch (exporter.method) {
      case 'download':
        this.selectedAll
          ? await this.exportAllReports(true, exporter.type)
          : await this.exportReports(true, exporter.type)
        break
      case 'mail':
        this.selectedAll
          ? await this.sendAllReports(exporter.type)
          : await this.sendReports(exporter.type)
        break
    }
  }

  async getReports(download, format) {
    try {
      this.tableLoading = true
      // @ts-ignore
      const codes = this.checkedRows.map((report) => report.proovCode)
      return await this.$api.reports.exportReportsWithParams(this.token, this.params, download, format, codes)
    } catch (error) {
      this.displayErrors(error)
    } finally {
      this.tableLoading = false
    }
  }

  async getAllReport(download, format) {
    try {
      this.tableLoading = true
      return await this.$api.reports.exportReportsWithParams(this.token, this.params, download, format)
    } catch (error) {
      this.displayErrors(error)
    } finally {
      this.tableLoading = false
    }
  }


  async exportAllReports(download, format) {
    try {
      const res = await this.getAllReport(download, format)

      downloadFileUrlWithoutBlob(`reports.${format}`, res.data.url)
    } catch (error) {
      this.displayErrors(error)
    }
  }

  async sendReports(format) {
    try {
      const res = await this.getReports(false, format)
      this.$toast.open({
        message: this.$t('reports.confirm_email_sent.message') as string,
        type: 'is-success'
      })
    } catch (error) {
      this.displayErrors(error)
    }
  }

  async sendAllReports(format) {
    try {
      const res = await this.getAllReport(false, format)
      this.$toast.open({
        message: this.$t('reports.confirm_email_sent.message') as string,
        type: 'is-success'
      })
    } catch (error) {
      this.displayErrors(error)
    }
  }

  async downloadReportPdf(report, state) {
    try {
      const payload = {
        proovCode: report.proovCode,
        state
      }
      const res = await this.$api.reports.downloadPdf(this.token, payload)
      downloadFileUrl(`${report.proovCode}_${state}.pdf`, res.data.url)
    } catch (error) {
      this.displayErrors(error)
    }
  }

  deleteReport(report) {
    this.$dialog.confirm({
      title: this.$t('global.info_box.warning') as string,
      message: this.$t('reports.confirm_deletion_modal.sub_title') as string,
      confirmText: this.$t('global.delete') as string,
      cancelText: this.$t('global.button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        try {
          this.tableLoading = true
          const res = await this.$api.reports.deleteReport(this.token, report.proovCode)
          this.data = this.data.filter((item) => item.proovCode !== report.proovCode )
          this.$toast.open({
            type: 'is-success',
            message: this.$t('reports.actions.delete.success.title') as string
          })
        } catch (error) {
          this.displayErrors(error)
        } finally {
          this.tableLoading = false
        }
      }
    })
  }
}
